import SEOHelmet from '@/components/base/SEOHelmet';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

const Home = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '韩漫屋 - 韩国漫画推荐首页',
    description: '韩漫屋提供韩国漫画和高质量漫画推荐韩漫在线免费阅读，资源新颖画质优良，是您漫画收藏的可靠平台。',
    url: 'https://hanmanwu.com/',
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '浪漫爱情', url: 'https://hanmanwu.com/category/romance' },
        { '@type': 'ListItem', position: 2, name: '热血动作', url: 'https://hanmanwu.com/category/action' },
        { '@type': 'ListItem', position: 3, name: '奇幻冒险', url: 'https://hanmanwu.com/category/fantasy' },
        { '@type': 'ListItem', position: 4, name: '悬疑推理', url: 'https://hanmanwu.com/category/thriller' },
        { '@type': 'ListItem', position: 5, name: '日常治愈', url: 'https://hanmanwu.com/category/slice-of-life' },
        { '@type': 'ListItem', position: 6, name: '剧情深度', url: 'https://hanmanwu.com/category/drama' },
      ],
    },
  };

  return (
    <>
      <SEOHelmet
        title="韩国漫画_高质量漫画推荐_韩漫在线免费阅读-韩漫屋"
        description="韩漫屋提供韩国漫画和高质量漫画推荐韩漫在线免费阅读，资源新颖画质优良，是您漫画收藏的可靠平台。涵盖浪漫、动作、奇幻、悬疑等多种类型的韩国漫画推荐。"
        keywords="韩国漫画,高质量漫画推荐,韩漫在线免费阅读,韩漫屋,韩漫推荐,韩国漫画在线阅读"
        canonicalUrl="https://hanmanwu.com/"
        schema={schema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedComics />
        <CategorySection />
        <LatestUpdates />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
};

export default Home;